module.exports = __webpack_public_path__ + "img/door.3dda0287.jpg";